import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7743e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "a-auth full-height" }
const _hoisted_2 = { class: "ion-padding a-auth__content-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Forgot password?", -1))
const _hoisted_4 = {
  key: 0,
  class: "load-wrap ion-text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-roller" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    "icon-only": "",
                    onClick: $options.back
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: $data.arrowBack }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Forgot password")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "ion-no-padding ion-padding-bottom",
        fullscreen: true,
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_ion_text, {
                color: "medium",
                class: "ion-margin-bottom"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Send me an email reset link")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                class: "ion-no-padding ion-padding-top",
                style: _normalizeStyle($options.valid($data.v.email))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [
                      _createTextVNode("E-mail")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: $data.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.email) = $event)),
                    class: "ion-padding-vertical",
                    name: "email",
                    type: "email",
                    onIonBlur: _cache[1] || (_cache[1] = ($event: any) => ($options.onBlur($data.v.email)))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["style"]),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
                : (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    disabled: $options.isFormInvalid,
                    class: "--default a-auth__button ion-margin-vertical",
                    onClick: $options.reset
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Reset my password")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}